import { createContext } from 'react';
export var PluginsContext = /*#__PURE__*/createContext(null);
PluginsContext.displayName = 'PluginsContext';
export default PluginsContext;
//# sourceMappingURL=PluginsContext.js.map